<template>
  <div>
    <el-transfer
      filterable
      :titles="['未选', '已选']"
      :value="agents"
      :data="data"
      @input="change($event)"
    >
    </el-transfer>
  </div>
</template>

<script>

import {fetchAgentList} from '../api/agent'
export default {
  data () {
    return {
      data: [],
      agents: []
    }
  },
  created () {
    let query = {}
    const data = []
    query.limit = 1000
    query.page = 1
    fetchAgentList(query).then((res) => {
      const _res = res.data.map((item) => { item.user_id = parseInt(item.user_id); return item })
      _res.forEach((item, index) => {
        data.push({
          label: item.company,
          key: item.user_id
        })
      })
      this.data = data
    })
  },
  mounted () {
    this.agents = this.value
  },
  props: ['value', 'config', 'size', 'showAllTip', 'showAllTipLabel'],
  methods: {
    change: function (val) {
      this.agents = val
      this.$emit('input', val)
    }
  },
  watch: {
    value (val) {
      this.agents = val
    }
  }
}
</script>

<style>
  @media screen and (min-width: 1300px) {
    .el-transfer-panel {
      width: 35%;
    }
  }
  @media screen and (max-width: 1300px) {
    .el-transfer-panel {
      width: 100%;
    }
  }

</style>



// WEBPACK FOOTER //
// src/card/components/AgentTransfer.vue